<template>
  <div class="pie">
    <svg
      :id="id"
    />
    <div class="showdata">
      {{ showdata }} {{ percdata }}
    </div>
    <div class="legend">
      {{ legend }}
    </div>
  </div>
</template>
<script>

import * as d3 from 'd3'

import commonMessages from '../../locales/common'

export default {
  name: 'Pie',
  i18n: {
    messages: {},
    sharedMessages: commonMessages,
  },
  props: {
    datum: {
      type: Object,
      default: () => {},
    },
    colors: {
      type: Object,
      default: () => {},
    },
    shown: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  data () {
    return {
      d3Pie: d3.pie().value((d) => { return d.value }),
      svg: undefined,
      width: 160,
      height: 160,
      margin: 20,
      showdata: ' ',
      percdata: ' ',
      legend: '',
    }
  },
  computed: {
    loc () {
      let loc = this.$i18n.locale
      if (this.$i18n.locale === 'eu') {
        loc = 'es'
      }
      const upper = loc.toUpperCase()
      return `${loc}-${upper}`
    },
    pieData () {
      return this.d3Pie(d3.entries(this.datum))
    },
    radius () {
      return Math.min(this.width, this.height) / 2 - this.margin
    },
    wHalf () {
      return this.width / 2
    },
    hHalf () {
      return this.height / 2
    },
    arcGenerator () {
      return d3.arc()
        .innerRadius(0)
        .outerRadius(this.radius)
    },
    colorScheme () {
      const colorScheme = Object.values(this.colors)
      return colorScheme
    },
    colorRange () {
      return d3.scaleOrdinal()
        .domain(this.datum)
        .range(this.colorScheme)
    },
  },
  watch: {
    datum () {
      this.g.remove()
      this.g = this.svg.append('g')
        .attr('transform', `translate(${this.wHalf}, ${this.hHalf})`)
      this.g
        .selectAll('slices')
        .data(this.pieData)
        .enter()
        .append('path')
        .attr('d', this.arcGenerator)
        .attr('class', 'pieItem')
        .attr('fill', (d) => { return this.colorRange(d.data.key) })
        .on('mouseover', (d, i, n) => {
          this.mouseoverPath(d, i, n)
        })
        .on('mouseout', (d, i, n) => {
          this.showdata = ' '
          this.percdata = ' '
          this.legend = ''
        })
        .on('click', (d, i, n) => {
          this.mouseoverPath(d, i, n)
        })
        // .attr('stroke', 'black')
        // .style('stroke-width', '2px')
    },
  },
  mounted () {
    this.svg = d3.select(`#${this.id}`)
      .attr('width', this.width)
      .attr('height', this.height)
      .attr('viewBox', [0, 0, this.width, this.height])
    this.g = this.svg.append('g')
      .attr('transform', `translate(${this.wHalf}, ${this.hHalf})`)
  },
  methods: {
    i18nRender (num) {
      return new Intl.NumberFormat(this.loc).format(num)
    },
    mouseoverPath (d, i, n) {
      this.showdata = this.i18nRender(d.data.value)
      this.percdata = '[' + this.i18nRender((d.data.value / this.total * 100).toFixed(2)) + '% ]'
      this.legend = this.$t(`txt.${d.data.key}`)
      /*
      d3.select(n[i]).attr({
        opacity: 'red',
        r: this.radius * 2,
      })
      */
    },
  },
}
</script>

<style lang="scss">

@import '@/mixin.scss';

.pie {
  margin-top: 1rem;
}

.showdata {
  min-height: 1.6rem;
  text-transform: uppercase;
}

.legend {
  min-height: 1rem;
  font-weight: 700;
  text-transform: uppercase;
  font-size: .72rem;
}

.pieItem {
  &:hover {
    opacity: .72;
  }
}

path {
  cursor: pointer;
}

</style>
